import { Link } from 'react-router-dom'

interface SectionHeadingProps {
  eyebrow?: string
  title: string
  description?: string
  actionLabel?: string
  actionTo?: string
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div className="min-w-0">
        {eyebrow && (
          <p className="mb-1 flex items-center gap-2 text-[11px] tracking-wide text-accent-700">
            <span className="h-1 w-1 rounded-full bg-accent-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">{title}</h2>
        {description && (
          <p className="mt-1.5 line-clamp-2 text-xs leading-5 text-foreground-500 md:text-sm">
            {description}
          </p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-600 transition-colors hover:text-accent-700 md:text-sm"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  )
}